import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "google-map",
  ref: "googleMap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapControls = _resolveComponent("MapControls")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    (_ctx.map)
      ? (_openBlock(), _createBlock(_component_MapControls, {
          key: 0,
          map: _ctx.map,
          onLabels: _ctx.onShowLabels
        }, null, 8, ["map", "onLabels"]))
      : _createCommentVNode("", true)
  ], 64))
}